"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _castArray = _interopRequireDefault(require("lodash/castArray"));

var _Icon = _interopRequireDefault(require("../../../IconicDisplayElements/Icon"));

var _AccordionSection = require("./AccordionSection.styles");

var _propTypes2 = _interopRequireDefault(require("../../../../constants/propTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AccordionSection = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AccordionSection, _React$PureComponent);

  var _super = _createSuper(AccordionSection);

  function AccordionSection(props) {
    var _this;

    _classCallCheck(this, AccordionSection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "collapseSection", function (elem, callback) {
      elem.removeEventListener('transitionend', elem);
      var height = elem.scrollHeight;
      var elemTransition = elem.style.transition;
      elem.style.transition = ''; // eslint-disable-line no-param-reassign

      elem.addEventListener('transitionend', function () {
        elem.removeEventListener('transitionend', elem);

        if (callback) {
          callback();
        }
      });
      requestAnimationFrame(function () {
        elem.style.height = "".concat(height, "px"); // eslint-disable-line no-param-reassign

        elem.style.transition = elemTransition; // eslint-disable-line no-param-reassign

        requestAnimationFrame(function () {
          elem.style.height = '0px'; // eslint-disable-line no-param-reassign

          if (callback) {
            callback();
          }
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "expandSection", function (elem, callback) {
      elem.removeEventListener('transitionend', elem);
      var height = elem.scrollHeight;
      elem.style.height = "".concat(height, "px"); // eslint-disable-line no-param-reassign

      elem.addEventListener('transitionend', function () {
        elem.removeEventListener('transitionend', elem);
        elem.style.height = null; // eslint-disable-line no-param-reassign

        if (callback) {
          callback();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleVisibility", function () {
      return _this.props.onToggleVisibility();
    });

    _defineProperty(_assertThisInitialized(_this), "wrapChildren", function () {
      var children = _this.props.children;
      var childArray = (0, _castArray.default)(children);
      return childArray.map(function (child, i) {
        // First check to see if the child is another AccordionSection
        return child.type && child.type.name === _this.constructor.name // Accordion Sections as children are treated as subSections - apply stying and a key
        ? _react.default.cloneElement(child, {
          key: i,
          className: 'c-accordion-section-sub-section'
        }) // eslint-disable-line react/no-array-index-key
        // Everything else will just be treated as a node tree that gets dumped into the parent section
        // these need a wrapper for styling and a key
        :
        /*#__PURE__*/
        _react.default.createElement("div", {
          key: i // eslint-disable-line react/no-array-index-key
          ,
          className: ['c-accordion-section-un-wrapped-content', 'c-accordion-section-sub-section'].join(' ')
        }, child);
      });
    });

    _this.state = {
      isOpen: props.isOpen
    };
    _this.contentRef = _react.default.createRef();
    return _this;
  }

  _createClass(AccordionSection, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.isOpen !== this.props.isOpen) {
        var elem = this.contentRef.current;

        if (this.props.isOpen) {
          this.expandSection(elem);
          this.setState({
            isOpen: this.props.isOpen
          });
        } else {
          this.collapseSection(elem, function () {
            return _this2.setState({
              isOpen: _this2.props.isOpen
            });
          });
        }
      }
    } // shamelessly borrowed from https://css-tricks.com/using-css-transitions-auto-dimensions/#article-header-id-5

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataTestId = _this$props.dataTestId,
          title = _this$props.title,
          subTitle = _this$props.subTitle,
          className = _this$props.className,
          isOpen = _this$props.isOpen;
      var wrapperOpen = this.state.isOpen;
      return /*#__PURE__*/_react.default.createElement(_AccordionSection.StyledAccordionSection, {
        className: ['c-accordion-section-styled-accordion', isOpen ? 'c-accordion-section-wrapper-open' : 'c-accordion-section-wrapper-closed', className].join(' '),
        "data-test-id": dataTestId,
        isOpen: isOpen
      }, /*#__PURE__*/_react.default.createElement("button", {
        "data-test-id": "accordion-section-toggle-btn",
        className: "c-accordion-section-title-wrapper",
        onClick: this.toggleVisibility
      }, /*#__PURE__*/_react.default.createElement("span", {
        "data-test-id": "accordion-section-left-title-wrapper",
        className: "c-accordion-section-left-title-wrapper"
      }, title), /*#__PURE__*/_react.default.createElement("span", {
        "data-test-id": "accordion-section-right-title-wrapper",
        className: "c-accordion-section-right-title-wrapper"
      }, /*#__PURE__*/_react.default.createElement("span", {
        "data-test-id": "accordion-section-sub-title",
        className: "c-accordion-section-sub-title"
      }, subTitle), /*#__PURE__*/_react.default.createElement(_Icon.default, {
        dataTestId: "accordion-section-icon",
        className: ['c-accordion-section-action-icon', isOpen ? 'c-accordion-section-action-icon-open' : ''].join(' '),
        iconName: "chevron-down"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "accordion-section-content-wrapper",
        className: ['c-accordion-section-content-wrapper', wrapperOpen ? 'c-accordion-section-content-wrapper-open' : '', isOpen ? 'c-accordion-section-content-wrapper-opening' : '' // intentionally using isOpen instead of wrapper in order to get the border on at the right time
        ].join(' '),
        ref: this.contentRef
      }, /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "accordion-section-own-content-wrapper",
        className: ['c-accordion-section-own-content-wrapper', isOpen ? 'c-accordion-section-own-content-wrapper-open' : ''].join(' ')
      }, this.wrapChildren())));
    }
  }]);

  return AccordionSection;
}(_react.default.PureComponent);

_defineProperty(AccordionSection, "propTypes", {
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /**
   * Flag indicating the display state of the sub-section
   */
  isOpen: _propTypes.default.bool,

  /**
   * Right-aligned secondary title for the sub-section
   */
  subTitle: _propTypes.default.string,

  /**
   * Left-aligned primary title for the sub-section
   */
  title: _propTypes.default.string,

  /**
   * Function to hoist visibility switches
   */
  onToggleVisibility: _propTypes.default.func,

  /**
   * If you want a child to look like an accordion section you MUST use the accordionSection component
   */
  children: _propTypes2.default.children
});

_defineProperty(AccordionSection, "defaultProps", {
  className: '',
  isOpen: false,
  subTitle: '',
  title: '',
  onToggleVisibility: function onToggleVisibility() {},
  children: undefined
});

var _default = AccordionSection;
exports.default = _default;